<div class="modal__content assign-score reportCommentModal">
  <button class="modal__close-btn" (click)="onClose()"><img src="../../../../../assets/images/close-circle.svg" /></button>
  <div class="assign-score__header">
    <h2 class="assign-score__title">Report comment</h2>
  </div>
  <div class="scrool">
    <div class="reaction__fields scrore">
      <label class="label__name">Add Reason for report comment*</label>
      <div class="popup__radio-group">
        <label class="popup__radio-option" [class.popup__radio-option--active]="reasonSelected === option" *ngFor="let option of options">
          <input
            type="radio"
            name="status"
            (click)="reasonSelected = option"
            [checked]="reasonSelected === option"
            class="popup__radio popup__radio--checkbox"
            [value]="option"
          />{{ option }}
        </label>
      </div>
    </div>
    <div class="reaction__fields scrore">
      <label class="label__name">Describe your reason</label>
      <textarea class="form__input form-control" [(ngModel)]="reason"></textarea>
    </div>
    <div class="assign-score__footer">
      <button class="assign-score__submit-btn" [disabled]="showSubmit(reason || '')" (click)="reason ? confirm() : null">Submit</button>
    </div>
  </div>
</div>
